import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Pagination } from "evergreen-ui";
import "./Blogs.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Newsletter from "./Newsletter";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const blogsPerPage = 6;

  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();

  const API_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
    AOS.refresh();

    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/blog`);
        if (!response.ok) throw new Error("Failed to fetch blogs");
        const data = await response.json();
        setBlogs(data);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError("Failed to load blogs.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [API_BASE_URL]);

  const handleClick = (blog) => {
    setSearchParams({ id: blog.id });
    navigate(`/blog-post?id=${blog.id}`);
  };

  // Pagination logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  // Fix pagination to allow next page even if exactly 6 blogs
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  if (loading) {
    return (
      <div className="blogPage-container">
        <div className="banner-blog">
          <div className="banner-sect">
            <p className="banner-title">BLOGS</p>
          </div>
        </div>
        <p className="blogPage-loadingText">Loading blogs...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blogPage-container">
        <div className="banner-blog">
          <div className="banner-sect">
            <p className="banner-title">BLOGS</p>
          </div>
        </div>
        <p className="blogPage-errorText">{error}</p>
      </div>
    );
  }

  return (
    <div className="blogPage-container">
      <div className="banner-blog">
        <div className="banner-sect">
          <p className="banner-title">BLOGS</p>
        </div>
      </div>

      <div data-aos="zoom-in-up" className="blogIntro-section">
        <p className="blogIntro-heading">
          Discover Stories, Insights, and Adventures from Across Africa.
        </p>
        <p className="blogIntro-description">
          Explore our collection of travel stories, tips, and experiences written by adventurers, travelers, and experts. Dive into inspiring narratives about culture, wildlife, and destinations across the continent.
        </p>
      </div>

      <div data-aos="zoom-in" className="blogGrid-wrapper">
        {currentBlogs.length === 0 ? (
          <p className="blogGrid-emptyMessage">No blogs available yet.</p>
        ) : (
          currentBlogs.map((blog) => (
            <div
              className="blogCard"
              key={blog.id}
              onClick={() => handleClick(blog)}
            >
              <div className="blogCard-imageWrapper">
                <img
                  src={`${API_BASE_URL}${blog.imagePath}`}
                  alt={blog.title}
                />
              </div>
              <div className="blogCard-content">
                <h5 className="blogCard-title">{blog.title}</h5>
                <p className="blogCard-description">
                  {blog.content.length > 180
                    ? blog.content.substring(0, 180) + "..."
                    : blog.content}
                </p>
                <p className="blogCard-meta">
                  <small>
                    By {blog.author} •{" "}
                    {blog.publishedAt
                      ? new Date(blog.publishedAt).toLocaleDateString()
                      : "Unknown date"}
                  </small>
                </p>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {blogs.length > blogsPerPage - 1 && (
        <div className="blogPagination-container">
          <Pagination
            page={currentPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}

      {/* Full-width Newsletter same as banner */}
      <div className="newsletter-fullwidth">
        <Newsletter />
      </div>
    </div>
  );
}

export default Blog;
